import React from 'react';
import { Table } from 'react-bootstrap';
import { hasAccessRights } from '../../../../../shared/functions/Functions';
import { AccessRightEnum } from '../../../../../enum/AccessRightEnum';
import { useTranslation } from 'react-i18next';

export interface IDashboardContractsListProps {
    children: JSX.Element;
}

export function DashboardContractList({ children }: IDashboardContractsListProps) {
    const isCharity = false;
    const { t } = useTranslation();
    return (
        <Table className="table-vertical-center dashboard-table mb-0">
            <thead className="border-bottom position-sticky bg-white" style={{ top: 0 }}>
                <tr>
                    <th className="text-start sticky-table-header">
                        {t('brand.campaign.dashboard.contracts.influencers')}
                    </th>
                    <th className="text-center sticky-table-header">
                        {t('brand.campaign.dashboard.contracts.post_used')}
                    </th>
                    <th className="text-center sticky-table-header">
                        {t('brand.campaign.dashboard.contracts.post_booked')}
                    </th>
                    <th className="text-center sticky-table-header">
                        {t('brand.campaign.dashboard.contracts.followers')}
                    </th>
                    <th className="text-center sticky-table-header">
                        {t('brand.campaign.dashboard.contracts.avg_reach')}
                    </th>
                    <th className="text-center sticky-table-header">
                        {t('brand.campaign.dashboard.contracts.avg_er')}
                    </th>
                    {!hasAccessRights(AccessRightEnum.MEASURE_HIDE_COSTS) && (
                        <>
                            <th className="text-center sticky-table-header">
                                {t('brand.campaign.dashboard.contracts.avg_cpm')}
                            </th>
                            <th className={`${isCharity ? 'd-none' : 'text-end'} sticky-table-header`}>
                                {t('brand.campaign.dashboard.contracts.cost')}
                            </th>
                        </>
                    )}
                </tr>
            </thead>
            <tbody>{children}</tbody>
        </Table>
    );
}
